import React from "react";

import Offer from "./Offer";

const noOffersMessage = () => (
  <h1>
    Sorry, we have no last-minute deals available at the moment, please
    check back soon!
  </h1>
);

const mapOffers = props => {
  const {
    consentStatement,
    isVenuePage,
    offers,
    selectLabel,
    venueName
  } = props;

  return (
    <div>
      {offers.map(offer => (
        <Offer
          key={offer.id}
          offer={offer}
          venueName={venueName}
          selectLabel={selectLabel}
          consentStatement={consentStatement}
          isVenuePage={isVenuePage}
        />
      ))}
    </div>
  );
};

const OffersList = props => {
  if (props.offers.length) {
    return mapOffers(props);
  }

  if (!props.hideNoOffersMessage) {
    return noOffersMessage();
  }

  return null;
};

export default OffersList;



// WEBPACK FOOTER //
// ./components/last_minute_deals/OffersList.js